(function () {
  const SELECTORS = [
    '.price-item',
    '.unit-price',
    '.cart-item__final-price',
    '.cart-item__old-price',
    '.cart-item__discounted-prices',
    '.totals__total-value',
    '.totals__subtotal-value',
    '.cart__discount',
    '.product__price',
    '[data-cart-subtotal]',
    // macade-custom-products + macade-recently-viewed-products
    '.related-items h5.subdued',
    // EliteCart upsell mini-cart (app-rendered)
    '.ec-lineitem-linetotal-price',
    '.ec-lineitem-price',
    '.ec-upsell-price',
    '.ec-cart-total',
  ].join(',');

  // EliteCart renders bare prices ("$235") while the theme cart shows
  // "$235 MXN" via money_with_currency — append the active currency code
  // there so the mini-cart matches.
  const CODE_SELECTORS = [
    '.ec-lineitem-linetotal-price',
    '.ec-lineitem-price',
    '.ec-upsell-price',
    '.ec-cart-total',
  ].join(',');

  // Shopify's money filter can use regular, non-breaking ( ) or narrow
  // no-break ( ) spaces as thousand separators depending on locale.
  const SEP_CLASS = '\\s\\u00a0\\u202f.,';
  const NUMBER_RE = new RegExp('\\d[\\d' + SEP_CLASS + ']*\\d', 'g');
  const SEP_RE = new RegExp('[' + SEP_CLASS + ']', 'g');
  // Some currency formats put a space between the symbol and the amount
  // (e.g. MXN renders "$ 900.00 MXN"). Collapse it so every currency reads
  // the same: "$900 MXN", "$70 CAD", "$45 USD".
  const SYMBOL_SPACE_RE = new RegExp('([$€£])[\\s\\u00a0\\u202f]+(?=\\d)', 'g');

  function stripPriceFormatting(text) {
    return text.replace(SYMBOL_SPACE_RE, '$1').replace(NUMBER_RE, (match) => {
      const noDecimals = match.replace(/[.,]\d{1,2}$/, '');
      return noDecimals.replace(SEP_RE, '');
    });
  }

  function appendCurrencyCode(el) {
    const code =
      window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!code) return;
    const text = el.textContent;
    if (!/\d/.test(text) || text.includes(code)) return;
    // Write into the last digit-bearing text node so any markup inside the
    // price element is left intact.
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    let last = null;
    while ((node = walker.nextNode())) {
      if (/\d/.test(node.nodeValue)) last = node;
    }
    if (last) last.nodeValue = last.nodeValue.replace(/\s+$/, '') + ' ' + code;
  }

  function cleanElement(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const next = stripPriceFormatting(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    if (el.matches && el.matches(CODE_SELECTORS)) appendCurrencyCode(el);
  }

  function clean(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(SELECTORS)) cleanElement(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTORS).forEach(cleanElement);
  }

  function init() {
    clean(document.body);
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'characterData') {
          // Apps (e.g. EliteCart) sometimes update prices by writing to
          // textContent of an existing span — that's a characterData mutation,
          // not childList, so we re-clean the nearest matching ancestor.
          const parent = m.target.parentElement;
          const ancestor = parent && parent.closest(SELECTORS);
          if (ancestor) cleanElement(ancestor);
          continue;
        }
        m.addedNodes.forEach((n) => {
          const parent = n.nodeType === 1 ? n : n.parentElement;
          const ancestor = parent && parent.closest && parent.closest(SELECTORS);
          if (ancestor) cleanElement(ancestor);
          clean(n);
        });
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
